import { Component, ChangeDetectionStrategy, Input, inject } from '@angular/core';
import { DmsBaseFolderAction } from '../dms-base-folder-action';
import { IrisDmsModalsSandbox } from '@iris/common/modules/dms/sandbox/dms-modals.sandbox';
import { IrisDmsRootFolder } from '@iris/common/modules/dms/models/IrisDMSFolder';
import { IrisDmsFoldersSandbox } from '@iris/common/modules/dms/sandbox/dms-folders.sandbox';
import { TranslatePipe } from '@ngx-translate/core';
import { take, tap } from 'rxjs/operators';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgClass } from '@angular/common';
import { MatMenuItem } from '@angular/material/menu';
import { StrakitButtonComponent } from '@ngx-strakit/cdk/controls';
import { StrakitButtonPrefixDirective } from '@ngx-strakit/cdk';

@Component({
  selector: 'iris-dms-import-zip-folder-button',
  templateUrl: './dms-import-zip-folder-button.component.html',
  styleUrls: ['./dms-import-zip-folder-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslatePipe,
    NgClass,
    MatTooltipModule,
    MatMenuItem,
    StrakitButtonComponent,
    StrakitButtonPrefixDirective,
  ],
})
export class IrisDmsImportZipFolderButtonComponent extends DmsBaseFolderAction {
  private readonly dmsModalsSandbox = inject(IrisDmsModalsSandbox);
  private readonly dmsFoldersSandbox = inject(IrisDmsFoldersSandbox);

  @Input() tooltipText = 'label.dms.ImportZipFolderToCurrent';

  protected _label = 'label.dms.ImportAsZip';

  public openUploadZipFolderModal(): void {
    const folderId = this.folderId() || IrisDmsRootFolder.id;
    this.dmsModalsSandbox.showUploadMinimizedModal(false);
    const modal = this.dmsModalsSandbox.showImportZipFolderModal(folderId);
    modal.onSuccess$.pipe(
      take(1),
      tap(() => this.dmsFoldersSandbox.getParentFolders(folderId)),
    ).subscribe();

    modal.onClose$.pipe(
      take(1),
      tap(() => this.dmsModalsSandbox.showUploadMinimizedModal(true)),
    ).subscribe();
  }
}
